<template>
  <v-dialog v-model="dialogVisible" width="50%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Redeem Coins</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-sheet>
      <v-form ref="form" v-model="coinsRules.valid">
        <v-container>
          <v-col> Select Coins to redeem </v-col>
          <v-col class="d-flex" cols="12" sm="8">
            <v-select
              :items="items"
              label="Select coins"
              v-model="coins"
              :rules="coinsRules.rules"
            ></v-select>
          </v-col>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          color="primary"
          text
          @click="redeemCoins()"
          :disabled="coinsRules.valid == false"
        >
          Redeem
        </v-btn>
      </v-card-actions>
    </v-sheet>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { BASE_URL, REDEEM_COINS } from "@/common/apiEndpoints";
import { getAxiosOptions } from "@/common/utility";
import { GET_TOKEN } from "@/store/getters";
import { mapGetters } from "vuex";

export default {
  name: "CoinHistoryRedeemDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coins: "",
      items: ["400", "800", "1200", "1600", "2000", "2400"],
      coinsRules: {
        valid: false,
        rules: [(v) => !!v || "This is required"],
      },
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.coins = "";
      this.$emit("input", false);
    },
    redeemCoins() {
      const url = REDEEM_COINS;
      const payload = {};
      payload.coins = this.coins;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.$emit("redeem-success");
          this.closeDialog();
        })
        .catch((error) => {
          error = error.errorMessage;
          this.closeDialog();
        });
    },
  },
};
</script>